import mindmap from "./mindmap";
import konvaCanvas from "./konvaCanvas";
import PvPgame from "./PvPgame";
import Molegame from "./Molegame";
import PvPTFgame from "./PvPTFgame";
import HTwbActKitHome from "./HTwbActKitHome";
import htwbcard from "./htwbcard";
import PickGame from "./PickGame";
import PunchBoard from "./PunchBoard";
import aiprompt from "./aiprompt";
import gameActManager from "./gameActManager";
import Snakegame from "./Snakegame";
import Mazegame from "./Mazegame";
export default {
  HTwbActKitHome,
  konvaCanvas,
  mindmap,
  PvPgame,
  Molegame,
  PvPTFgame,
  htwbcard,
  PickGame,
  PunchBoard,
  aiprompt,
  gameActManager,
  Snakegame,
  Mazegame,
  Game: {
    pushSuccess: "遊戲已推送成功，並可在遊戲管理頁面檢視",
    pushFailed: "推送失敗：{message}",
    tokenRefreshing: "Token 即將刷新，請稍後重試"
  },
  refreshToken: "刷新token",
  確定: "確定",
  取消: "取消",
  //Navigator
  測試: "測試",
  HT資源網: "HT資源網",
  布題頁面: "HiTeach5 布題頁面",
  音訊: "音訊",
  影片: "影片",
  教材:"教材",
  教案:"教案",
  背景圖: "背景圖",
  測驗卷: "測驗卷",
  後台管理: "後台管理",
  檢舉管理: "檢舉管理",
  所有上傳管理: "所有上傳管理",
  管理者後台: "管理者後台",
  登入: "登入",
  設定: "設定",
  登出: "登出",
  搜尋: "搜尋...",
  暫無資料: "暫無資料",
  推薦教材: "推薦教材",
  的搜尋結果: "的搜尋結果...",
  分類: "分類",
  全部: "全部",
  //後續可能會改輸入方式
  年級: "年級",
  科目: "科目",
  排序: "排序",
  時間: "時間",
  標題: "標題",
  附件: "附件",
  無法播放的格式: "無法播放的格式",
  直接下載提示字: "目前無法以播放器預覽之格式，請直接下載",

  下載: "下載",
  簡介: "簡介",
  上傳者: "上傳者",
  相關教材: "相關教材",
  個人簡介: "個人簡介",
  已貢獻教材數: "已貢獻教材數",
  被管理員設置為隱藏之教材: "被管理員設置為隱藏之教材",
  簡介文字: "簡介文字",
  儲存: "儲存",
  更新: "更新",
  語系: "語系",

  //檢舉頁面
  檢舉管理時間: "檢舉管理-時間",
  檢舉管理教材: "檢舉管理-教材",
  檢舉搜尋提示時間: "僅可搜尋被檢舉上傳者姓名、檢舉者姓名, 教材標題欄位...",
  檢舉搜尋提示教材: "僅可搜尋被檢舉上傳者姓名、教材標題欄位",
  檢視模式: "檢視模式:",
  按時間近到遠: "按時間近到遠",
  按教材ID匯總: "按教材ID匯總",
  未處理: "未處理",
  已處理: "已處理",
  未隱藏: "未隱藏",
  已隱藏: "已隱藏",
  檢舉時間: "檢舉時間",
  檢舉流水號: "檢舉流水號",
  檢舉者: "檢舉者",
  檢舉代碼: "檢舉代碼",
  檢舉理由: "檢舉理由",
  審批狀態: "審批狀態",
  審批時間: "審批時間",
  接受: "接受",
  不受理: "不受理",
  編輯: "編輯",
  刪除: "刪除",
  刪除提示: "刪除提示",
  刪除提示內文: "確定刪除這份教材嗎? 刪除後將無法復原!",

  一鍵接受: "一鍵接受",
  一鍵不受理: "一鍵不受理",
  檢舉: "檢舉",

  //常用material欄位
  教材Id: "教材Id",
  類型: "類型",
  點擊數: "點擊數",
  授課語系: "授課語系",
  標籤: "標籤",
  隱藏: "隱藏",

  //Msg
  更新成功: "更新成功!",
  刪除成功: "刪除成功!",

  "reportmsg-form": {
    檢舉教材表單: "檢舉教材表單",
    檢舉教材名稱: "檢舉教材名稱",
    檢舉原因: "檢舉原因",
    錯誤或無法使用的檔案格式: "錯誤或無法使用的檔案格式",
    有害或誤導性的內容: "有害或誤導性的內容",
    侵權內容: "侵權內容",
    其他原因: "其他原因",
    描述: "描述",
    敘明原因提示字: "本檢舉表單會根據您的登入帳號留下紀錄，請務必敘明原因，提供管理人員審查是否屬實",
    送出: "送出",
    取消: "取消",
  },
  "editmaterial-form": {
    編輯教材資訊: "編輯教材資訊",
    標題: "標題",
    介紹: "介紹",
    年級: "年級",
    未指定: "未指定",
    科目: "科目",
    授課語系: "授課語系",
    自訂標籤: "自訂標籤",
    標籤提示字: "*請用逗號分隔,ex: 二元一次方程式,三角函數",
  },
  webirs:{
    konvaCanvas: {
      比例:'比例',
      //AddImageBox
      檔案圖片:'檔案圖片',
      素材庫:'素材庫',
      選取圖片作為物件:'選取圖片作為物件',
      背景設置:'背景設置',
      選取圖片作為背景:'選取圖片作為背景',
      //AddTextBox & TextSetting
      文字工具:'文字便利貼工具',
      編輯文字便利貼:'編輯',
      "openURL_NewTab": "於新分頁檢視連結",
      刪除文字便利貼:'刪除',
      複製文字便利貼:'複製一份',
      輸入文字: '輸入文字',
      字體大小:'字體大小',
      字體顏色:'字體顏色',
      顏色:'顏色',
      便利貼顏色:'便利貼顏色',
      確定:'確定',
      取消:'取消',
      //PenSetting
      畫筆:'畫筆',
      通用畫筆:'通用畫筆',
      高光筆:'螢光筆',
      鐳射筆:'雷射筆',
      大小:'大小',
      //ShapeSetting
      圖形:'圖形',
      邊框:'邊框',
      填充:'填充',
      箭頭:'箭頭',
      直線:'直線',
      圓形:'圓形',
      橢圓:'橢圓',
      矩形:'矩形',
      三角形:'三角形',
      星形:'星形',
      所選圖片過大:'所選圖片過大(應小於3MB)，請重新選擇！',
      打開點擊的物件連結:'打開點選的物件連結?',
      多連結詢問:'偵測到點擊的物件含有多個有效連結，請選擇一個動作',
      目前沒有動作可復原: '目前沒有動作可復原',
      復原我最近一次刪除動作:'復原我最近一次刪除動作!',
      ModifyHint: '內容有作過修改, 離開將不會儲存, 請問仍然要離開嗎?',
      物件化畫板:'物件化畫板',
      重新整理圖層:'重新整理圖層!',
      刪除鎖定物件提示字:'刪除了教師鎖定的物件，可點擊還原或重開教材!',
      協作無法刪除鎖定提示字:'協作無法刪除教師鎖定的物件!',
      複製:'複製一份',
      刪除:'刪除',
      移到最上層:'移到最上層',
      移到最下層:'移到最下層',
      回放中:'重播中...',
      暫停:'暫停',
      標準:'標準',
      快速:'快速',
      教師:"教師"
    },
    mindmap:{
      新增:'新增節點',
      編輯:'編輯節點',
      輸入文字: '輸入文字',
      確定:'確定',
      取消:'取消',
      請先選取節點:'請先選取節點!',
      不可刪除有子項目的節點:'不可刪除有子項目的節點!',
      新增失敗:'新增失敗，父節點已被刪除!',
      編輯失敗:'編輯失敗，所選節點已被刪除!',
      加入根節點:'加入根節點',
      左邊:'左邊',
      右邊:'右邊',
      已是最上面:'已是最上面!',
      已是最下面:'已是最下面!',
      圖片:'圖片',
      圖片過大提示字1:'所選圖片過大(請小於',
      圖片過大提示字2:'MB)，請重新選擇！',
      連結:'連結',
      連結網址:'連結網址',
      連結名稱:'連結名稱',
      輸入URL:'輸入URL...',
      輸入連結名稱:'輸入連結名稱...',
      註解:'註解',
      進階設定:'進階設定',
      線條顏色:'線條顏色',
      節點顏色:'節點顏色',
      markDownNoData: '轉換後無有效節點資料!',
      markDownErr:'所提供的Markdown資料無法轉換!',
      preEditHint:'注意：目前的節點之前編輯者是',
      confirmUpdate:'，確定要修改嗎?',
      moveNodeTitle:'移動節點',
      moveNodeHint:'請選擇父節點',
      noTopic:'無主題',
      share:'上雲端',
      createSuccess:'MindMap 建立成功，準備跳轉',
      initSharingFailed:'分享初始化失敗，請重試',
      authError:'請重試翻頁嘗試更新授權',
      unexpectedError:'發生未預期的錯誤，請重試',
      menu:{
        新增:'新增',
        刪除:'刪除',
        上移:'上移',
        下移:'下移',
        左移:'左移',
        右移:'右移',
        編輯:'編輯',
        複製:'複製',
        檢視圖片:'檢視圖片',
        最後更新:'最後更新',
        檢視節點變更記錄:'檢視節點變更記錄',
        lock:'鎖定',
        unlock:'解鎖',
        move:'移動',
        applyColor:'套用色彩',
        allRightLayout:'全向右佈局',
        allRightLayoutSuccess:'已將所有第一層子節點調整為右側佈局',
        allLeftLayout:'全向左佈局',
        allLeftLayoutSuccess:'已將所有第一層子節點調整為左側佈局',
        noChildrenToApply:'根節點沒有子節點可以套用',
      },
      treeMenu:{
        currentMoveNode:'要移動的節點 (包含子節點)',
        selectedParentNode:'選取為父節點'
      },
      imgEditor:{
        詢問離開動作:"詢問離開動作?",
        保存圖片:'保存圖片',
        捨棄變更:'捨棄變更',
        取消:'取消',
      },
      nodeHistory:{
        節點歷史:'節點歷史',
        動作:'動作',
        編輯者:'編輯者',
        內容:'內容',
        線條顏色:'線條顏色',
        節點顏色:'節點顏色',
        註解:'註解',
        add:'新增',
        update:'更新',
      },
      askJumpSharing:{
        title:'要使用Sharing網站-雲端的心智圖嗎?',
        confirm:'確定',
        cancel:'取消',
      }

    }
  }
};
